import styled, {css} from "styled-components"

import padding from "@irati/ui/src/global/padding"
import media, {minWidthMedia} from "@irati/ui/src/global/media"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Button from "@irati/ui/src/Button"

export default styled.div`
  margin: ${padding.tiny} 0;
  text-transform: ${(props) => (props.capitalise ? "capitalize" : "none")};

  ${minWidthMedia.tablet`
    margin: ${padding.base} 0;
  `}
`

export const GridWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${media.tablet`
    flex-direction: column;
    align-items: flex-start;
    justify-content: initial;
  `}
`

export const Primary = styled.div`
  display: flex;
  align-items: center;

  ${minWidthMedia.tablet`
    width: 70%;
    padding-right: 50px;
  `}
`

export const Image = styled.img`
  width: 60px;
  margin-right: 20px;

  ${minWidthMedia.tablet`
    width: 80px;
  `}
`

const ButtonStyles = css`
  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${media.tablet`
    margin: 20px 0 10px;
  `}

  ${minWidthMedia.tablet`
    width: 30%;
  `}
`

export const StyledButtonRouterLink = styled(ButtonRouterLink)`${ButtonStyles}`
export const StyledButton = styled(Button)`${ButtonStyles}`
